import React from 'react';
import { matchPath, useLocation } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Hooks
import { useOrganization } from 'Shared/utils/hooks/use-organization';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useToggle } from 'Shared/utils/hooks';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Components
import WpBanner from 'Wpds/components/banner/WpBanner';
import { WpButton } from 'Wpds/components/button';
import { WpText } from 'Wpds/components/text';
import { WpIcon } from 'Wpds/components/icon';
import CharmaLegacySunsetModal from '../CharmaLegacySunsetModal/CharmaLegacySunsetModal';

// Styles
import './BannerSunsetLegacyCharma.scss';

const BannerSunsetLegacyCharma = () => {
  const { pathname } = useLocation();
  const { isLoggedIn, user } = useCurrentUser();
  const { isPiOrganization } = useOrganization();
  const { featureFlagEnableCharmaSunsetMessaging } = useFlags();
  const { tr } = useTranslation();

  const [isOpen, toggleIsOpen] = useToggle(false);
  const isOnboardingRoute = matchPath(pathname, { path: [PageUrlsConstants.ONBOARDING_WIZARD] });

  // don't show if FF is not enabled
  if (!featureFlagEnableCharmaSunsetMessaging) return null;
  // don't show if not logged in
  if (!isLoggedIn) return null;
  // don't show for existing PI orgs
  if (isPiOrganization) return null;
  // don't show if user is still signing up
  if (isOnboardingRoute) return null;
  // don't show if onboarding is not completed
  if (user && !user.onboarding?.completed_at) return null;

  const baseClassName = 'BannerSunsetLegacyCharma';
  return (
    <>
      <WpBanner type="purple">
        <div className={baseClassName}>
          <WpText color="white-0" noMargin>
            <span className={`${baseClassName}__icon`}>
              <WpIcon name="exclamation-circle" />
            </span>
            <WpText color="white-0" noMargin bold tag="span">
              {tr('perform.assistants.banner.action_required')}
            </WpText>{' '}
            {tr('perform.assistants.banner.deactivation_message')}
          </WpText>

          <div className={`${baseClassName}__btn`}>
            <WpButton size="sm" color="white" onClick={toggleIsOpen}>
              {tr('perform.assistants.banner.see_details')}
            </WpButton>
          </div>
        </div>
      </WpBanner>
      {isOpen && <CharmaLegacySunsetModal onDismiss={toggleIsOpen} />}
    </>
  );
};

export default BannerSunsetLegacyCharma;
